import TableSorting from './TableSorting.vue';
export default TableSorting;
